// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar-group {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* Aligns items horizontally */
}

.avatar {
  width: 30px;
  /* Adjust the size as needed */
  height: 30px;
  border-radius: 50%;
  background-color: #f1f1f1;
  /* Light background color */
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #333;
  font-size: 12px;
  border: 1px solid #ccc;
  /* Optional border */
  margin-left: -13px;
  /* Overlap effect */
  z-index: 1;
}

.avatar:first-child {
  margin-left: 0;
  /* No negative margin for the first avatar */
}`, "",{"version":3,"sources":["webpack://./../interview/src/components/InterviewCard/components/Participants/AttendeesAvatar.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EAA6B,8BAAA;AAE/B;;AACA;EACE,WAAA;EAAa,8BAAA;EACb,YAAA;EACA,kBAAA;EACA,yBAAA;EAA2B,2BAAA;EAC3B,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EAAwB,oBAAA;EACxB,kBAAA;EAAoB,mBAAA;EACpB,UAAA;AAMF;;AAHA;EACE,cAAA;EAAgB,4CAAA;AAOlB","sourcesContent":[".avatar-group {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start; /* Aligns items horizontally */\n}\n\n.avatar {\n  width: 30px; /* Adjust the size as needed */\n  height: 30px;\n  border-radius: 50%;\n  background-color: #f1f1f1; /* Light background color */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  color: #333;\n  font-size: 12px;\n  border: 1px solid #ccc; /* Optional border */\n  margin-left: -13px; /* Overlap effect */\n  z-index: 1;\n}\n\n.avatar:first-child {\n  margin-left: 0; /* No negative margin for the first avatar */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
